import React, { useEffect, useState } from "react";
import { Button, Col, Row, Table } from "react-bootstrap";
import { useNavigate } from 'react-router-dom'
import inventoryApi from "../api/inventoryApi";
import moment from "moment";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader
} from 'react-bs-datatable';
import { Link } from "react-router-dom";
import ReportMonthFilterBar from "./ReportMonthFilterBar"; // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)


const CbrWorkerReportList = () => {
    const navigate = useNavigate();
    const now = new Date(); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    const [body, setBody] = useState([]);
    const [useMonthFilter, setUseMonthFilter] = useState(true); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    const [filterYear, setFilterYear] = useState(now.getFullYear()); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
    const [filterMonth, setFilterMonth] = useState(now.getMonth() + 1); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)

    useEffect(() => {
        // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
        async function init() {
            const result = useMonthFilter
                ? await inventoryApi.fetchCbrWorkerReports(filterYear, filterMonth)
                : await inventoryApi.fetchCbrWorkerReports();
            setBody(Array.isArray(result) ? result : []);
        }
        init();
    }, [useMonthFilter, filterYear, filterMonth]); // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)


    const header = [
        {
            title: 'Name', prop: 'name', isFilterable: true,
            cell: (row) => (
                <Link
                    to={"/cbrworkerreport/" + row.id + "/e"}
                    state={row}
                >
                    {row.name}
                </Link>
            )
        },
        { title: 'Project Name', prop: 'projectname', isFilterable: true },
        { title: 'CBR Field area', prop: 'cbrfieldarea', isFilterable: true },
        { title: 'Date', prop: 'cbrdate', isFilterable: true, cell: (row) => moment(row.cbrdate).format('MM/DD/YYYY'), }, // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026)
        { title: 'Name of Incahrge', prop: 'inchargename', isFilterable: true },

    ];

    const labels = {
        beforeSelect: ""
    }

    const createCbrWorker = () => {
        navigate(`/cbrworkerreport/e`);
    }


    return (
        <Row className="g-0">
            <Col lg={2} className="mx-2">
                <Link className="nav-link">Home <i class="fa-solid fa-chevron-right"></i> CBR Worker</Link>
            </Col>
            <Col lg={12} className="p-lg-4">
            {/* // Added By Jaseem => CBR Reports Filter Month Wise (27-04-2026) */}
                <ReportMonthFilterBar
                    useMonthFilter={useMonthFilter}
                    onUseMonthFilterChange={setUseMonthFilter}
                    year={filterYear}
                    month={filterMonth}
                    onYearChange={setFilterYear}
                    onMonthChange={setFilterMonth}
                />
                {body ?
                    <DatatableWrapper body={body} headers={header} paginationOptionsProps={{
                        initialState: {
                            rowsPerPage: 15,
                            options: [5, 10, 15, 20]
                        }
                    }}>
                        <Row className="mb-4">
                            <Col
                                xs={12}
                                lg={4}
                                className="d-flex flex-col justify-content-end align-items-end"
                            >
                                <Filter />
                            </Col>
                            <Col
                                xs={12}
                                sm={6}
                                lg={4}
                                className="d-flex flex-col justify-content-start align-items-start"
                            >
                                <PaginationOptions labels={labels} />
                            </Col>
                            <Col
                                xs={12}
                                sm={6}
                                lg={4}
                                className="d-flex flex-col justify-content-end align-items-end"
                            >
                                <Button className="btn-sm" variant="outline-primary" onClick={() => createCbrWorker(true)}>Create Worker</Button>
                            </Col>
                        </Row>
                        <Table striped className="data-table">
                            <TableHeader />
                            <TableBody />
                        </Table>
                        <Pagination />

                    </DatatableWrapper> : ''}
            </Col>
            <Col lg={2}></Col>
        </Row>
    )
}

export default CbrWorkerReportList
